module.exports = __webpack_public_path__ + "static/media/ios.52114969.png";